import { useEffect } from "react";
import { KeyboardEventKeys } from "../../typings/types";
import isNotEmpty from "../../utils/isNotEmpty";
var useEscClick = function useEscClick(ref, action) {
  useEffect(function () {
    var handleKeyDown = function handleKeyDown(event) {
      if (event.key === KeyboardEventKeys.ESC && isNotEmpty(ref.current)) {
        action(event);
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return function () {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [ref, action]);
};
export default useEscClick;